import { render, staticRenderFns } from "./SpreadImage.vue?vue&type=template&id=5605af66&scoped=true&"
import script from "./SpreadImage.vue?vue&type=script&lang=js&"
export * from "./SpreadImage.vue?vue&type=script&lang=js&"
import style0 from "./SpreadImage.vue?vue&type=style&index=0&id=5605af66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605af66",
  null
  
)

export default component.exports